import { useState } from "react";
import Papa from "papaparse";
import { useDispatch } from "react-redux";
import errorToast from "./error-toast";
const useCsvUpload = (actionType, expectedHeaders) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const onError = (data) => {
    errorToast(data?.data?.message);
    setLoading(false);
  };

  const validateAndDispatch = (parsedData, onSuccess) => {
    if (!parsedData || parsedData.length === 0 || !parsedData[0]) {
      errorToast(
        "Error: The file is empty or contains no valid records."
      );
      setLoading(false);
      return;
    }
    const fileHeaders = Object.keys(parsedData[0]);
    const isValidTemplate = expectedHeaders.every((header) =>
      fileHeaders.includes(header)
    );
    if (!isValidTemplate) {
      errorToast(
        "Error: File template does not match the required format."
      );
      setLoading(false);
      return;
    }
    dispatch(
      actionType(
        parsedData,
        (data) => {
          setLoading(false);
          onSuccess(data);
        },
        onError
      )
    );
  };

  const handleFileUpload = async (event, onSuccess) => {
    const file = event?.target?.files?.[0];
    if (!file) return;
    event.target.value = "";
    setLoading(true);

    const isJsonFile = file.name?.toLowerCase().endsWith(".json");

    if (isJsonFile) {
      let parsedData;
      try {
        const fileText = await file.text();
        parsedData = JSON.parse(fileText);
      } catch (error) {
        errorToast("Error: Failed to parse JSON file.");
        setLoading(false);
        return;
      }
      validateAndDispatch(parsedData, onSuccess);
      return;
    }

    try {
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: async (results) => {
          const parsedData = results.data;
          validateAndDispatch(parsedData, onSuccess);
        },
      });
    } catch (error) {
      errorToast("Error: Failed to process CSV file.");
      //   onError && onError(error);
      setLoading(false);
    }
  };
  return { handleFileUpload, loading };
};
export default useCsvUpload;
